var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'font-family':_vm.item.font,'font-size':_vm.item.fontSize})},[_vm._v("\n    "+_vm._s(_vm.item.text)+"：\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }